import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./MeetingVideo.css";

import "../../Homepage/BusinessTravel/BusinessTravel.css";

const MeetingVideo = () => {
  return (
    <>
      {/* ..........................meeting and event budget............................ */}
      <div className="tech-solutions mt-md-5 mt-3">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mt-md-5 pt-md-4">
              <h3 className="text-center headings">
                Plan Your Perfect Meeting{" "}
                <span style={{ fontWeight: "bold", color: "black" }}>& </span>{" "}
                Event Within Budget
              </h3>
            </div>
            <div className="col-md-12 d-flex justify-content-center mt-2 mt-md-3">
              <div className="carouselCaption text-black">
                <a href="/contact">
                  <button className="btn text-black fw-bold text-uppercase">
                    Contact Us Today
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MeetingVideo;
